export default __webpack_public_path__ + "static/media/trash-347.7086299a.svg";